import { ColDef } from 'ag-grid-community';
import { SalesPerformanceAmount } from '../Dto_SAL2050_R01';

const formatAmount = (value: number | null | undefined): string => {
	return (value ?? 0).toLocaleString();
};

const formatRate = (value: number | null | undefined): string => {
	return (value ?? 0).toLocaleString(undefined, {
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	});
};

export const getTabGridOptions = () => ({
	ensureDomOrder: true,
	suppressRowHoverHighlight: true,
	pagination: false,
	maxBlocksInCache: 10,
	blockLoadDebounceMillis: 100,
	suppressBrowserResizeObserver: true,
	suppressPropertyNamesCheck: true,
	debounceVerticalScrollbar: true,
	debounceHorizontalScrollbar: true,
	suppressCellChangeFlash: true,
});

const SALES_AMOUNT_FIELDS: { headerName: string; field: keyof SalesPerformanceAmount; width: number }[] = [
	{ headerName: '전년매출액', field: 'prevYearSalesAmt', width: 130 },
	{ headerName: '당년매출액', field: 'currYearSalesAmt', width: 130 },
	{ headerName: '증감액', field: 'diffAmt', width: 130 },
];

const SALES_RATE_FIELD: { headerName: string; field: keyof SalesPerformanceAmount; width: number } = {
	headerName: '증감율(%)',
	field: 'diffRate',
	width: 110,
};

const salesAmountColumns = (): ColDef[] => [
	...SALES_AMOUNT_FIELDS.map(({ headerName, field, width }) => ({
		headerName,
		colId: field,
		field,
		width,
		type: 'numericColumn',
		editable: false,
		valueFormatter: (p: any) => formatAmount(p.value),
	})),
	{
		headerName: SALES_RATE_FIELD.headerName,
		colId: SALES_RATE_FIELD.field,
		field: SALES_RATE_FIELD.field,
		width: SALES_RATE_FIELD.width,
		type: 'numericColumn',
		editable: false,
		valueFormatter: (p: any) => formatRate(p.value),
	},
];

export const getCustomerSalesColumns = (): ColDef[] => [
	{ headerName: '사업장코드', colId: 'compCd', field: 'compCd', width: 110, editable: false },
	{ headerName: '사업장명', colId: 'compNm', field: 'compNm', width: 130, editable: false },
	{ headerName: '거래처', colId: 'customCd', field: 'customCd', width: 110, editable: false },
	{ headerName: '상호', colId: 'customNm', field: 'customNm', width: 160, editable: false },
	...salesAmountColumns(),
	{ headerName: '비고', colId: 'remark', field: 'remark', width: 200, editable: false },
];

export const getItemSalesColumns = (): ColDef[] => [
	{ headerName: '사업장코드', colId: 'compCd', field: 'compCd', width: 110, editable: false },
	{ headerName: '사업장명', colId: 'compNm', field: 'compNm', width: 130, editable: false },
	{ headerName: '품목코드', colId: 'itemCd', field: 'itemCd', width: 140, editable: false },
	{ headerName: '품명', colId: 'itemNm', field: 'itemNm', width: 180, editable: false },
	{ headerName: '규격', colId: 'itemSpec', field: 'itemSpec', width: 140, editable: false },
	...salesAmountColumns(),
	{ headerName: '비고', colId: 'remark', field: 'remark', width: 200, editable: false },
];
